<div class="weather-card-skeleton">

  <div class="weather-card-skeleton__live">
    <ngx-skeleton-loader [theme]="skeletonDotTheme"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="skeletonLiveLabelTheme"></ngx-skeleton-loader>
  </div>

  <div class="weather-card-skeleton__air">
    <ngx-skeleton-loader [theme]="skeletonAirLabelTheme"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="skeletonAirValueTheme"></ngx-skeleton-loader>
  </div>

  <div class="weather-card-skeleton__main">
    <ngx-skeleton-loader [theme]="skeletonIconTheme"></ngx-skeleton-loader>
    <div class="weather-card-skeleton__info">
      <ngx-skeleton-loader [theme]="skeletonConditionTheme"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="skeletonTempTheme"></ngx-skeleton-loader>
    </div>
  </div>

</div>
